module.exports = __webpack_public_path__ + "static/media/EPOS-TSU-Logo_notext.436ad7c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/EPOS-TSU-Logo_notext.png
// module id = 882
// module chunks = 0